export default "__VITE_ASSET__BIZgSjs1__"